<template>
  <v-dialog
    :model-value="modelValue"
    max-width="420"
    persistent
    @update:model-value="emitClose"
  >
    <v-card class="logout-card">
      <v-card-title class="logout-card__title">
        Выход из аккаунта
      </v-card-title>
      <v-card-text class="logout-card__text">
        Вы уверены, что хотите выйти? Сессия завершится, и понадобится повторный вход.
      </v-card-text>
      <v-card-actions class="logout-card__actions">
        <v-btn
          variant="outlined"
          class="logout-card__cancel"
          @click="emitClose(false)"
          :disabled="loading"
        >
          Отмена
        </v-btn>
        <v-btn
          class="logout-card__confirm"
          color="error"
          variant="flat"
          @click="$emit('confirm')"
          :loading="loading"
        >
          Выйти
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue';

defineProps<{
  modelValue: boolean;
  loading?: boolean;
}>();

const emit = defineEmits(['update:modelValue', 'confirm']);

const emitClose = (value: boolean) => {
  emit('update:modelValue', value);
};
</script>

<style scoped>
.logout-card {
  border-radius: 14px;
  box-shadow: 0 20px 48px rgba(17, 24, 39, 0.18);
  padding: 6px 6px 10px;
  background: linear-gradient(180deg, #ffffff 0%, #f9fafb 100%);
}

.logout-card__title {
  font-weight: 700;
  font-size: 18px;
  padding: 12px 20px 4px;
  color: #111827;
}

.logout-card__text {
  color: #4b5563;
  font-size: 14px;
  padding: 0 20px 8px;
  line-height: 1.5;
}

.logout-card__actions {
  justify-content: flex-end;
  gap: 12px;
  padding: 0 16px 14px;
}

.logout-card__cancel {
  border-color: #e5e7eb;
  color: #374151;
  border-radius: 12px;
  text-transform: none;
  font-weight: 600;
}

.logout-card__confirm {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: #fff;
  box-shadow: 0 12px 28px rgba(220, 38, 38, 0.28);
  border-radius: 12px;
  text-transform: none;
  font-weight: 700;
}

.logout-card__confirm:hover {
  background: linear-gradient(135deg, #f87171, #dc2626);
}
</style>
